import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const HeroSection = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <section id="hero" className="relative h-[85vh] min-h-[600px] overflow-hidden">
      {/* Background Image - using img element for LCP optimization */}
      <div className="absolute inset-0" style={{ contain: 'layout paint' }}>
        <img
          src="/images/hockey-hero-optimized.webp"
          alt=""
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="sync"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-background/20" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-transparent to-background/40" />
      </div>

      {/* Ice particles effect - hidden on mobile for performance, reduced count on desktop */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none hidden md:block" style={{ contain: 'strict' }}>
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-ice-glow/30 rounded-full animate-float"
            style={{
              left: `${(i * 25) + 12}%`,
              top: `${(i * 20) + 15}%`,
              animationDelay: `${i * 1.2}s`,
              animationDuration: `${6 + (i % 2)}s`,
              transform: 'translateZ(0)',
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 h-full flex flex-col justify-center">
        <div className="max-w-3xl animate-slide-in">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-1 w-12 bg-primary rounded-full" />
            <span className="text-primary font-medium tracking-wider text-sm uppercase">
              {t.heroExtra.season}
            </span>
          </div>
          
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold leading-tight mb-6">
            {t.hero.title.split(" ").slice(0, -1).join(" ")}
            <span className="block text-primary">{t.hero.title.split(" ").slice(-1)}</span>
          </h1>
          
          <p className="text-muted-foreground text-lg md:text-xl max-w-xl mb-3 leading-relaxed">
            {t.hero.subtitle}
          </p>
          
          <p className="text-primary/80 font-medium text-sm md:text-base mb-8 max-w-lg">
            {t.heroExtra.alertsLine}
          </p>
          
          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => document.getElementById('live-games')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-primary text-primary-foreground font-display text-lg font-semibold rounded-lg hover:bg-primary/90 transition-all duration-300 hover:scale-105"
            >
              {t.hero.watchLive}
            </button>
            <button 
              onClick={() => navigate('/schedule')}
              className="px-8 py-4 bg-secondary/80 backdrop-blur-sm text-secondary-foreground font-display text-lg font-semibold rounded-lg border border-border hover:bg-secondary transition-all duration-300 hover:scale-105"
            >
              {t.hero.fullSchedule}
            </button>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>
  );
};

export default HeroSection;
